<!-- Legal Layout Component -->
<div class="legal-page">
  <!-- Header -->
  <app-header></app-header>

  <!-- Legal Content -->
  <section class="legal-section section-pad" style="background-color: #f0eada;">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-9">
          <!-- Header -->
          <div class="legal-header mb-5">
            <a routerLink="/" class="back-link mb-4 d-inline-flex align-items-center">
              <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24" style="margin-right: 8px;">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
              </svg>
              Volver al Inicio
            </a>
            <h1 class="legal-title mb-3">{{ title }}</h1>
            @if (lastUpdated) {
              <p class="legal-date text-accent">Última actualización: {{ lastUpdated }}</p>
            }
          </div>

          <!-- Content -->
          <div class="legal-content">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Footer -->
  <app-footer></app-footer>
</div>

